import styled from 'styled-components';

const FooterStyle = styled.div`
  .btn-tertiary {
    background-color: #3AAA3A !important;
    border-color: #3AAA3A;
  }
`;

export default FooterStyle;